import type {PropsWithChildren} from 'react'
import {createContext, use, useMemo} from 'react'

interface BaseUrlContextState {
  baseUrl: string
}

const BaseUrlContext = createContext<BaseUrlContextState | null>(null)

export function BaseUrlContextProvider({children, baseUrl}: PropsWithChildren<BaseUrlContextState>) {
  const contextValue = useMemo<BaseUrlContextState>(() => ({baseUrl}), [baseUrl])
  return <BaseUrlContext value={contextValue}>{children}</BaseUrlContext>
}

export function useBaseUrl() {
  const context = use(BaseUrlContext)

  if (!context) {
    throw new Error('useBaseUrl must be used within a BaseUrlContextProvider.')
  }

  return context.baseUrl
}
